import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const useFetchCommunityPeople = () => {
    const [people, setPeople] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const { getAccessTokenSilently } = useAuth0();
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const controller = new AbortController();

        const fetchPeople = async () => {
            setLoading(true);
            setError('');

            try {
                const token = await getAccessTokenSilently({
                    authorizationParams: {
                        audience: process.env.REACT_APP_API_AUDIENCE,
                    },
                });
                const response = await fetch(`${apiUrl}/api/users/shared-communities`, {
                    headers: { Authorization: `Bearer ${token}` },
                    signal: controller.signal,
                });

                if (!response.ok) {
                    throw new Error(`Community people request failed (${response.status})`);
                }

                setPeople(await response.json());
            } catch (requestError) {
                if (requestError.name !== 'AbortError') {
                    console.error('Failed to load people from shared communities', requestError);
                    setError("We couldn't load people from your communities right now.");
                }
            } finally {
                if (!controller.signal.aborted) setLoading(false);
            }
        };

        fetchPeople();
        return () => controller.abort();
    }, [apiUrl, getAccessTokenSilently]);

    return { people, loading, error };
};
